export const ok = '#009DDC';
export const caution = '#FFAA00';
export const warning = '#D34626';
export const offline = '#BBBBBB';
export const primary = '#da7721';
export const hBlack = '#000000';
export const gTemp = '#00A980';
export const valueZ = '#f26529'